var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlusBcJaune(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ebbc02;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        font-size: 47px;\n        font-family: Heebo;\n        font-weight: 700;\n      }\n\n      .cls-3 {\n        filter: url(#Ellipse_22);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_22",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_622",
    "data-name": "Groupe 622",
    transform: "translate(-101 -554)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, 101, 554)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22-2",
    "data-name": "Ellipse 22",
    className: "cls-1",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    className: "cls-2",
    transform: "translate(127 606)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBcJaune);
export default __webpack_public_path__ + "static/media/icon_Plus_BC_Jaune.cafb452bd4ab34b3a04590002c9bf26b.svg";
export { ForwardRef as ReactComponent };